export default __webpack_public_path__ + "static/media/tapir99.b8b47458.png";